"use strict";

var _toConsumableArray = require("C:/Project/Fred-New/source/PhrameBooth-Web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var cache = new Map();

function get(property, value) {
  return cache.get(property + value);
}

exports.get = get;

function set(property, value, className) {
  if (process.env.NODE_ENV !== 'production') {
    var valueType = typeof value;

    if (valueType !== 'boolean' && valueType !== 'number' && valueType !== 'string') {
      var encodedValue = JSON.stringify(value);
      throw new TypeError("\uD83D\uDCE6 ui-box: invalid cache value \u201C".concat(encodedValue, "\u201D. Only booleans, numbers and strings are supported."));
    }
  }

  cache.set(property + value, className);
}

exports.set = set;

function entries() {
  return _toConsumableArray(cache);
}

exports.entries = entries;

function hydrate(newEntries) {
  cache = new Map([].concat(_toConsumableArray(cache), _toConsumableArray(newEntries)));
}

exports.hydrate = hydrate;

function clear() {
  cache.clear();
}

exports.clear = clear;